import type { Error } from '../types';
import { CONTAIN_LETTER_REGEXP } from '../utils/regex';

export const mustContainLetter =
  (message?: Error['message'], allowEmpty = true) =>
  (value: string): Error => {
    const valid = !!value && CONTAIN_LETTER_REGEXP.test(value);
    return {
      valid: allowEmpty ? !value || valid : valid,
      message
    };
  };
